/**
 * OaSIS Explorer Frontend - Theme Toggle Component
 * Task 3.1: Frontend Foundation & Global Features
 * 
 * Theme switching component with smooth transitions
 */

import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts';
import { useTranslation } from '../../contexts';

/**
 * Theme toggle button component
 */
export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const t = useTranslation();

  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={t('a11y.themeToggle')}
      className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700"
    >
      <div className="relative">
        {/* Sun icon for light mode */}
        <Sun
          size={20}
          className={`transition-all duration-300 ${
            isDark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'
          }`}
          style={{ position: isDark ? 'absolute' : 'static' }}
        />
        
        {/* Moon icon for dark mode */}
        <Moon
          size={20}
          className={`transition-all duration-300 ${
            isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0'
          }`}
          style={{ position: isDark ? 'static' : 'absolute', top: 0, left: 0 }}
        />
      </div>
    </button>
  );
};

